<template>
  <div class="spinners" v-if="spinners">
    <atom-spinner :animation-duration="1000" :size="100" color="#ff1d5e" />
  </div>
  <div class="error-alert bg-danger" v-if="(controlPLC?.errorCode >= 100 || controlPLC?.calibrationData?.status) && this.auth?.authority">
    <atom-spinner :animation-duration="1000" :size="30" color="white" />
    <span v-if="!controlPLC?.calibrationData?.status">{{ `${$t('errorCode')} ${controlPLC?.errorCode}` }} : {{
      $t(`calf.errorDesc.${controlPLC?.errorCode}`) }}</span>
    <span v-else>{{ $t('calf.errorDesc.152') }}</span>

    <atom-spinner :animation-duration="1000" :size="30" color="white" />
  </div>
  <header v-if="this.auth.authority">
    <ul>
      <li @click="collapse"><i class="fas fa-bars btn-aside zoom"></i></li>
    </ul>
    <div class="fs-6">
      <p style="width: 125px" class="text-center" v-if="license">
        <span v-if="this.auth.tecnicalPersonal">{{ `${$t('developer')} ${this.$store.state.systemDate.slice(10,
          19)}` }}</span>
        <span v-else>{{ this.$store.state.systemDate }}</span>
      </p>
      <p v-else>
        <span class="btn bg-danger text-white fs-5">{{ $t('copyCard') }}</span>
      </p>
    </div>
    <ul>
      <li id="fsBtn" v-if="this.authority" @click="logout()">
        <!-- style="color:#5396da;" -->
        <i class="fas fa-sign-out-alt"></i>
      </li>
      <li id="fsBtn" v-else @click="this.$router.push({ query: { login: 'login' } })">
        <i class="fas fa-sign-in-alt"></i>
      </li>
      <li>
        <span class="fs-3 opacity-75">{{ this.config?.sub_id }}</span>
      </li>
      <li id="fsBtn" @click="fullScreen">
        <i class="fas fa-expand-arrows-alt zoom"></i>
      </li>
    </ul>
  </header>

  <nav v-if="this.auth.authority">
    <div class="logo-details big">
      <div id="logo-small" class="logo d-none" v-if="this.producer != undefined">
        <img v-if="producer.title == 'itech'" src="@/assets/media/img/logo.png" alt="" style="object-fit: contain" />
        <img v-else-if="producer.title == 'sezer'" src="@/assets/media/img/sezer.png" alt=""
          style="object-fit: contain" />
        <img v-else-if="producer.title == 'dairysense'" src="@/assets/media/img/dairysense.png" alt=""
          style="object-fit: contain" />
      </div>
      <div id="logo-big" class="logo" v-if="this.producer != undefined">
        <img v-if="producer.title == 'itech'" src="@/assets/media/img/logo2.png" alt="" style="object-fit: contain" />
        <img v-else-if="producer.title == 'sezer'" src="@/assets/media/img/sezer2.png" alt=""
          style="object-fit: contain" />
        <img v-else-if="producer.title == 'dairysense'" src="@/assets/media/img/dairysense.png" alt=""
          style="object-fit: contain" />
      </div>
    </div>
    <ul class="nav-list">
      <li class="nav-item">
        <div class="input-area-single">
          <select class="input" name="mixtureLiter" id="mixtureLiter" v-model="selected_machine">
            <option v-for="(item, index) in this.$store.state.machine_data" :key="index" :value="item.machine_id">
              {{ item.code }}
            </option>
          </select>
        </div>
      </li>
      <!-- <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-home"></i>
          <router-link class="nav-title fw-bold" to="/profil">{{ $t('') }}</router-link>
        </a>
      </li> -->
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-home"></i>
          <router-link class="nav-title fw-bold" to="/">{{ $t('nav.home') }}</router-link>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-paw"></i>
          <router-link class="nav-title fw-bold" to="/calf">{{ $t('calfs') }}</router-link>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-paw"></i>
          <router-link class="nav-title fw-bold" to="/calf/calfOperations">{{ $t('nav.transactions') }}</router-link>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-chart-line"></i>
          <router-link class="nav-title fw-bold" to="/calf/consumption">{{ $t('nav.consumptions') }}</router-link>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-chart-line"></i>
          <router-link class="nav-title fw-bold" to="/calf/remainder">{{ $t('nav.visits') }}</router-link>
        </a>
      </li>
      <li class="nav-item" v-if="!this.$store.state.systems?.banExternalFeeding">
        <a class="nav-link">
          <i class="fas fa-paw"></i>
          <router-link class="nav-title fw-bold" to="/externalFeeding">{{ $t('nav.externalSupply') }}</router-link>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-paw"></i>
          <router-link class="nav-title fw-bold" to="/specialfeeding">{{ $t('nav.feedingProgram') }}</router-link>
        </a>
      </li>
      <li class="nav-item" v-if="true">
        <a class="nav-link">
          <i class="fas fa-paw"></i>
          <router-link class="nav-title fw-bold" to="/health">{{ $t('nav.healthMonitoring') }}</router-link>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-paw"></i>
          <router-link class="nav-title fw-bold" to="/treatments">{{ $t('nav.treatments') }}</router-link>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-paw"></i>
          <router-link class="nav-title fw-bold" to="/archive">{{ $t('nav.archives') }}</router-link>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-exclamation-circle"></i>
          <router-link class="nav-title fw-bold" to="/errorlog">{{ $t('nav.alerts') }}</router-link>
        </a>
      </li>
      <hr v-if="this.auth?.authority" />
      <li class="nav-item" v-if="this.auth?.authority">
        <a class="nav-link" @click="dropdown($event)">
          <i class="fas fa-lock-open"></i>
          <i class="fas fa-chevron-down arrow"></i>
          <span class="nav-title fw-bold">{{ $t('nav.n_control', { name: $t('general') }) }}</span>
        </a>
        <ul class="sub-nav">
          <li class="nav-item" v-if="this.auth.tecnicalPersonal">
            <a class="nav-link">
              <i class="fas fa-spinner"></i>
              <router-link class="nav-title fw-bold" to="/panel/tracking/system">{{ $t('nav.n_control', {
                name:
                  $t('system')
              }) }}</router-link>
            </a>
          </li>
          <li class="nav-item" v-if="this.auth.tecnicalPersonal">
            <a class="nav-link">
              <i class="fas fa-spinner"></i>
              <router-link class="nav-title fw-bold" to="/panel/tracking/liquid">{{ $t('liquidLevel') }}</router-link>
            </a>
          </li>
          <li class="nav-item" v-if="this.auth.tecnicalPersonal && this.systems?.baummerTracking">
            <a class="nav-link">
              <i class="fas fa-spinner"></i>
              <router-link class="nav-title fw-bold" to="/panel/technical/baummer">{{ $t('items.baummer')
              }}</router-link>
            </a>
          </li>
          <li class="nav-item" v-if="this.auth.tecnicalPersonal">
            <a class="nav-link">
              <i class="fas fa-spinner"></i>
              <router-link class="nav-title fw-bold" to="/panel/tracking/statistics">{{ $t('statistics')
              }}</router-link>
            </a>
          </li>
          <li class="nav-item" v-if="this.auth.tecnicalPersonal">
            <a class="nav-link">
              <i class="fas fa-spinner"></i>
              <router-link class="nav-title fw-bold" to="/panel/tracking/license">{{ $t('license.license')
              }}</router-link>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <i class="fas fa-spinner"></i>
              <router-link class="nav-title fw-bold" to="/panel/network">{{ $t('internet') }}</router-link>
            </a>
          </li>
          <li class="nav-item" v-if="this.auth?.authority">
            <a class="nav-link">
              <i class="fas fa-chart-line"></i>
              <router-link class="nav-title fw-bold" to="/panel/calibration/ports">{{ $t('nav.n_control', {
                name: $t('port')
              }) }}</router-link>
            </a>
          </li>
        </ul>
      </li>
      <li class="nav-item" v-if="this.auth?.authority">
        <a class="nav-link" @click="dropdown($event)">
          <i class="fas fa-lock-open"></i>
          <i class="fas fa-chevron-down arrow"></i>
          <span class="nav-title fw-bold">{{ $t('nav.calibrations') }}</span>
        </a>
        <ul class="sub-nav">
          <li class="nav-item" v-if="this.auth?.authority">
            <a class="nav-link">
              <i class="fas fa-wrench"></i>
              <router-link class="nav-title fw-bold" to="/panel/technical/components">{{ $t('general') }}</router-link>
            </a>
          </li>
          <li class="nav-item" v-if="this.auth.tecnicalPersonal">
            <a class="nav-link">
              <i class="fas fa-wrench"></i>
              <router-link class="nav-title fw-bold" to="/panel/technical/stationCalibration">{{ $t('n_station')
              }}</router-link>
            </a>
          </li>
          <li class="nav-item"
            v-if="this.config?.systems?.liquitSuplament || this.config?.systems?.liquitSuplament2 || this.config?.systems?.powderSuplament">
            <a class="nav-link">
              <i class="fas fa-wrench"></i>
              <router-link class="nav-title fw-bold" to="/panel/calibration/systems">{{ $t('system') }}</router-link>
            </a>
          </li>
          <li class="nav-item" v-if="this.auth.tecnicalPersonal && false">
            <a class="nav-link">
              <i class="fas fa-wrench"></i>
              <router-link class="nav-title fw-bold" to="/suplaments">{{ $t('support') }}</router-link>
            </a>
          </li>
        </ul>
      </li>
      <li class="nav-item" v-if="this.auth?.authority">
        <a class="nav-link">
          <i class="fas fa-microchip"></i>
          <router-link class="nav-title fw-bold" to="/panel/tracking/follow">
            {{
              $t('nav.n_tracking', {
                name: $t('services.plc')
              })
            }}
          </router-link>
        </a>
      </li>
    </ul>
    <div class="nav-profil">
      <div class="profil-img" v-if="this.producer != undefined" @click="userSettings">
        <img v-if="producer.title == 'itech'" src="@/assets/media/img/logo.png" alt="" style="object-fit: contain" />
        <img v-else-if="producer.title == 'sezer'" src="@/assets/media/img/sezer.png" alt=""
          style="object-fit: contain" />
        <img v-else-if="producer.title == 'dairysense'" src="@/assets/media/img/dairysense.png" alt=""
          style="object-fit: contain" />
      </div>

      <p class="profil-name line-limit" v-if="this.producer != undefined">{{ this.producer.name }}</p>
    </div>
  </nav>

  <main class="container-xxxl" v-if="this.auth.authority">
    <div class="content">
      <div class="main-header">
        <p class="page-name">{{ this.breadcrumb[this.breadcrumb?.length - 1] }}</p>
        <ul class="breadcrumb">
          <li>
            <a href="/">{{ $t('nav.home') }}</a>
          </li>
          <li v-for="(item, index) in this.breadcrumb" :key="index">{{ item }}</li>
        </ul>
      </div>
      <router-view @breadcrumb="breadcrumb = $event" />
    </div>
    <div class="perde" v-if="navOptionsBarShow" @click="navOptionsBar0()"></div>
    <div id="navOptionsBar" class="nav-options-bar">
      <div class="door-handle" @click="navOptionsBar0()">
        <i class="fas fa-cog bg-transparent"></i>
      </div>
      <div class="content">
        <div class="text-center mb-2">
          <p class="btn btn-sm btn-success">{{ `${$t('version')}: ${this.machineCode} v${this.version}` }}</p>
        </div>
        <div class="nob-header">
          <p class="title mb-2 fw-bold">{{ $t('systemConf') }}</p>
        </div>
        <div class="row justify-content-center my-3">
          <div class="col-4 lang-box mb-2" @click="change_lang('tr')">
            <img src="@/assets/media/img/lang/tr.png" alt="" class="user-img-sm"/>
          </div>
          <div class="col-4 lang-box mb-2" @click="change_lang('az')">
            <img src="@/assets/media/img/lang/az.png" alt="" class="user-img-sm"/>
          </div>
          <div class="col-4 lang-box mb-2" @click="change_lang('en')">
            <img src="@/assets/media/img/lang/en.png" alt="" class="user-img-sm"/>
          </div>
          <div class="col-4 lang-box mb-2" @click="change_lang('ru')">
            <img src="@/assets/media/img/lang/ru.png" alt="" class="user-img-sm"/>
          </div>
          <div class="col-4 lang-box mb-2" @click="change_lang('de')">
            <img src="@/assets/media/img/lang/de.png" alt="" class="user-img-sm"/>
          </div>
          <div class="col-4 lang-box mb-2" @click="change_lang('ar')">
            <img src="@/assets/media/img/lang/ar.png" alt="" class="user-img-sm"/>
          </div>
        </div>
        <ul class="nob-services">
          <div class="row">
            <div class="text-center">
              <p class="fw-bold">{{ $t('services.services') }}</p>
            </div>
            <!-- <div class="col-12" v-if="this.authority">
              <li class="service text-center active" @click="this.serviceReboot('boot')">
                <span>{{ $t('rebootCard') }}</span>
              </li>
            </div> -->
            <div class="col-7" v-if="this.authority">
              <li class="service text-center active" @click="this.serviceReboot('cf-guardian')">
                <span>{{ $t('services.guardian') }}</span>
              </li>
            </div>
            <div class="col-5" v-if="this.authority">
              <li class="service text-center active" @click="this.serviceReboot('cf-crm')">
                <span>{{ $t('services.crm') }}</span>
              </li>
            </div>
            <div class="col-12" v-if="services">
              <div class="row justify-content-center">
                <div class="col-6" v-for="(item, index) in services.filter(x => x.name != 'RFID')" :key="index">
                  <li class="service text-center" @click="this.serviceReboot(item.service)"
                    :class="{ active: item.counter >= 5 }">
                    <span>{{ $t(`services.${item.name.toLowerCase()}`) }}</span>
                  </li>
                </div>
                <div class="col-3" v-for="(item, index) in services.filter(x => x.name == 'RFID' && x.status)"
                  :key="index">
                  <li class="service text-center" @click="this.serviceReboot(item.service)"
                    :class="{ active: item.counter >= 5 }">
                    <span>{{ `R${item.stationID + 1}` }}</span>
                  </li>
                </div>
              </div>
            </div>

            <div class="text-center">
              <hr />
              <p class="title mb-2 fw-bold">{{ $t('fastAccess') }}</p>
            </div>
            <div class="col-12 mt-2">
              <button type="button" class="btn btn-sm btn-outline-success w-100" @click="this.$router.go()">
                {{ $t('refreshPage') }}
              </button>
            </div>
            <div class="col-12 mt-2">
              <button type="button" class="btn btn-sm btn-outline-success w-100" :disabled="!this.dataFastAccess.reboot"
                :class="{ 'btn-outline-danger': !this.dataFastAccess.reboot }"
                @click="fastAccess('reboot', `${$t('reboot')}`)">
                {{ $t('reboot') }}
              </button>
            </div>
            <div class="col-6 mt-2">
              <button type="button" class="btn btn-sm btn-outline-warning w-100" :disabled="!this.dataFastAccess.reboot"
                :class="{ 'btn-outline-danger': !this.dataFastAccess.reboot }"
                @click="fastAccess('automatic', `${$t('mode.descAutomatic')}`)">
                {{ $t('mode.automatic') }}
              </button>
            </div>
            <div class="col-6 mt-2">
              <button type="button" class="btn btn-sm btn-outline-warning w-100" :disabled="!this.dataFastAccess.reboot"
                :class="{ 'btn-outline-danger': !this.dataFastAccess.reboot }"
                @click="fastAccess('manual', `${$t('mode.descManual')}`)">
                {{ $t('mode.manual') }}
              </button>
            </div>
            <div class="offset-3 col-6 mt-2" v-if="controlPLC?.errorCode >= 100">
              <button type="button" class="btn btn-sm btn-outline-success w-100"
                @click="fastAccess('errorReset', `${$t('errorReset')}`)">
                {{ $t('errorReset') }}
              </button>
            </div>
            <div class="col-12 mt-2">
              <button type="button" class="btn btn-sm btn-outline-success w-100" :disabled="!controlPLC?.washingStatus"
                @click="fastAccess('washingNormal', `${$t('wash_normal')}`)"
                :class="{ 'btn-outline-danger': !controlPLC?.washingStatus }">
                {{ $t('wash_normal') }}
              </button>
            </div>
            <div class="col-12 mt-2" v-if="this.authority">
              <button type="button" class="btn btn-sm btn-outline-success w-100" :disabled="!controlPLC?.washingStatus"
                @click="fastAccess('washingAcid', `${$t('wash_acid')}`)"
                :class="{ 'btn-outline-danger': !controlPLC?.washingStatus }">
                {{ $t('wash_acid') }}
              </button>
            </div>
            <div class="col-12 mt-2" v-if="this.$store.state.systems?.mix">
              <button type="button" class="btn btn-sm btn-outline-success w-100" :disabled="!controlPLC?.washingStatus"
                @click="fastAccess('getMilk', `${$t('getMilk')}`)"
                :class="{ 'btn-outline-danger': !controlPLC?.washingStatus }">
                {{ $t('getMilk') }}
              </button>
            </div>

            <div class="col-12">
              <div class="text-center mt-3">
                <p class="title mb-2 fw-bold">{{ $t('extraControl') }}</p>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-6">
                  <span>{{ $t('liquidLevel') }}</span>
                </div>
                <div class="col-6">
                  <div class="status-manager">
                    <span class="status" :class="{ 'bg-success': this.controlPLC?.liquidLevel1 }"></span>
                    <span class="status" :class="{ 'bg-success': this.controlPLC?.liquidLevel2 }"></span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <ul class="d-flex flex-column m-0 p-0" v-if="this.controlPLC?.errorCode != undefined">
                <li class="mb-3 rounded-3 px-4 py-2 bg-info fw-bold" v-if="this.controlPLC?.tempBoiler < 1400">
                  <i class="fas fa-temperature-low"></i>
                  <span class="ms-2">{{ `${$t('boiler')}: ${(this.controlPLC?.tempBoiler / 10).toFixed(1)}` }}°</span>
                </li>
                <li class="mb-3 rounded-3 px-4 py-2 bg-info fw-bold" v-if="this.controlPLC?.tempMixer < 1400">
                  <i class="fas fa-temperature-low"></i>
                  <span class="ms-2">{{ `${$t('mixer')} ${(this.controlPLC?.tempMixer / 10).toFixed(1)} °` }}</span>
                </li>
                <li class="mb-3 rounded-3 px-4 py-2 bg-info fw-bold" v-if="this.controlPLC?.tempOutdoor < 1400">
                  <i class="fas fa-temperature-low"></i>
                  <span class="ms-2">{{ `${$t('weather')} ${(this.controlPLC?.tempOutdoor / 10).toFixed(1)}°` }}</span>
                </li>
              </ul>
            </div>
            <div>
              <hr />
            </div>
          </div>
        </ul>
      </div>
    </div>
  </main>
  <footer v-if="this.auth.authority">
    <div class="content">
      <p>{{ `© 2025` }}</p>
      <p>{{ $t(`calf.errorDesc.${controlPLC?.errorCode}`) }}</p>
      <p>{{ `${this.machineCode} v${this.version}` }}</p>
    </div>
  </footer>
  <div class="specialLoginArea" v-if="!this.auth?.authority">
    <loginPage />
  </div>
</template>

<style>
.specialLoginArea {
  position: absolute;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
}

:root {
  --c-theme: #5396da;
}
</style>

<script>
import { mapMutations } from 'vuex'
import { AtomSpinner } from 'epic-spinners'
import loginPage from '@/login.vue'

export default {
  components: {
    AtomSpinner,
    loginPage
  },
  data() {
    return {
      devStatus: false,
      machineCode: 'CFR',
      version: '4.107.0_1',
      time: 0,
      breadcrumb: [this.$t('nav.home')],
      selected_machine: localStorage.selected_machine,
      externalToken: undefined,
      externalSelectedMachine: undefined,
      machineAddr: {
        'CFR': 'imom',
        'FPR': 'ibold',
        'SPR': 'ican',
        'CPM': 'colostrum'
      },
      currentMachine: undefined,
      config: undefined,
      spinners: true,
      dataFastAccess: {
        reboot: true,
        errorReset: true
      },
      navOptionsBarShow: false,
      externalFeedingStatus: true,
      systemDate: {
        autoSet: false,
        date: '0000-00-00',
        hour: '00:00:00'
      },
      changeDateStatus: false
    }
  },
  methods: {
    ...mapMutations(['collapse', 'fullScreen', 'navOptionsBar', 'logout']),
    dropdown(event) {
      event.target.parentElement.parentElement.classList.toggle('active');
      event.target.parentElement.parentElement.classList.toggle('open');
    },
    navOptionsBar0() {
      this.navOptionsBar();
      this.navOptionsBarShow = !this.navOptionsBarShow;
    },
    async serviceReboot(service) {
      if (await this.$f.alerts_check(this.$t('alerts.restartService'))) {
        this.$axios.post({ uri: '/serviceReboot', valueData: { value: service } });
      }
    },
    async fastAccess(type, desc) {
      if (await this.$f.alerts_check(this.$t('alerts.n_areYouSure', { name: type }))) {
        if (type == 'reboot') {
          this.dataFastAccess.reboot = false;
          this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'M', addr: 43, value: 1, after: 0 } });
          setTimeout(() => {
            this.dataFastAccess.reboot = true;
          }, 5000);
        } 
        else if (type == 'manual') this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'M', addr: 0, value: 1 } });
        else if (type == 'automatic') this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'M', addr: 0, value: 0 } });
        else if (type == 'errorReset') this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'D', addr: 98, value: 1 } });
        else if (type == 'washingNormal') this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'M', addr: 345, value: 0, after: 1 } });
        else if (type == 'washingAcid') this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'M', addr: 348, value: 0, after: 1 } });
        else if (type == 'getMilk') this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'M', addr: 150, value: 1 } });
        this.$alertBox.info(this.$t('op.completed', { name: desc }));
      }
    },
    async change_lang(lang) {
      localStorage.lang = lang || 'tr';
      this.$router.go();
    },
    async closePopup() {
      this.$router.replace({ query: null });
      this.pageNumber = 1;
    },
    async dateChange() {
      const systemDate = this.systemDate;
      if (await this.$f.alerts_check(this.$t('alerts.areYouSure'))) {
        await this.$axios.post({ port: 4000, uri: '/date', valueData: systemDate });
      }
    },
    async checkByToken() {
      const val = Number(this.externalSelectedMachine);
      if (val && !isNaN(val)) {
        localStorage.selected_machine = this.externalSelectedMachine
        this.$router.push({ query: null })
      }

      if (this.externalToken?.length > 0) {
        localStorage.token = this.externalToken
        this.$router.push({ query: null })
      }

      if (localStorage.token && localStorage.token != undefined) {
        try {
          debugger
          var req = await this.$axios.get({ orjUri: '/checkByToken' })
          if (req.newToken) {
            const response = req
            localStorage.token = response?.newToken
            this.$store.state.auth = {
              authority: true,
              role: response?.role,
              mail: response?.mail,
              time: response?.exp,
              authorization: response?.authority,
              tecnicalPersonal: req.authority?.machine?.read ? true : false,
              machines: response?.machines
            }
          } else this.logout()
        } catch (error) {
          if (error.response) this.$alertBox.warning(error.response.data)
          else console.error(error.message)
          this.logout()
          this.$router.go()
        }
      } else this.logout()
      this.spinners = false
      if (this.$route.query.token?.length > 0) this.$router.push({ query: {} })
    },
    async exitAccount() {
      if (await this.$f.alerts_check(this.$t('login.areYouSure_logout'))) {
        this.logout()
      }
    },
    async getMyMachines() {
      const machine_data = await this.$axios.get({ orjUri: '/machines/getMyMachine' })
      this.$store.state.machine_data = machine_data.data
        ?.filter((x) => x.remote_ip != null)
        .sort((a, b) => a.code?.split("-")[1] - b.code.split("-")[1]);
      let machineList = this.$store.state.machine_data

      let findMachine = this.selected_machine ? machineList?.find(x => x.machine_id == this.selected_machine) : machineList.find(x => x.code.split('-')[0] == this.machineCode)

      if (findMachine?.machine_id != this.selected_machine) this.selected_machine = findMachine?.machine_id

      if (!findMachine && machineList?.length > 0) {
        let subDomain = this.machineAddr[machineList[0]?.code?.split('-')[0]] 
        if (window.location.host.split('.')[0] != subDomain && !this.devStatus) {
          this.baseControl(subDomain)
        }
      }
      await this.$socket.connect()
    },
    async baseControl(subDomain) {
      if (this.$store.state.auth.authority && subDomain) {
        // eslint-disable-next-line
        const baseURL = `https://${subDomain}.itechrobotics.com.tr`
        if (!this.devStatus) window.location.href = `${baseURL}?externalToken=${localStorage.token}&externalSelectedMachine=${this.selected_machine}`
      }
    },
  },
  async mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.externalToken = urlParams.get('externalToken')
    this.externalSelectedMachine = urlParams.get('externalSelectedMachine')

    await this.checkByToken();
    if (Number(this.externalSelectedMachine)) {
      localStorage.selected_machine = Number(this.externalSelectedMachine)
      this.$router.go()
    }
    await this.getMyMachines()
    if (window.innerWidth <= 960) {
      document.querySelector('body').classList.add('collapse')
    }

    if (!this.selected_machine && this.authority) {
      const firstAlert = setInterval(() => {
        if (this.config?.producer) clearInterval(firstAlert);
        else this.$alertBox.warning(this.$t('alerts.awaitMachine'));
      }, 5000);
    }
    this.config = await this.$axios.get({ port: 4000, uri: '/config' });
    setTimeout(() => {
      if (localStorage.token && localStorage.token != undefined) {
        if (!this.config) this.$router.go();
      }
    }, 10000);
    if (this.authority) {
      this.$store.state.errorCodeDesc = await this.$axios.get({ uri: '/systemlog/errordesc' })
      const errorCodeDescInterval = setInterval(async () => {
        if (this.$store.state.errorCodeDesc != undefined) clearInterval(errorCodeDescInterval)
        else this.$store.state.errorCodeDesc = await this.$axios.get({ uri: '/systemlog/errordesc' })
      }, 5000)
    }

    let configCounter = 15;
    const configInterval = setInterval(async () => {
      if (localStorage.token && localStorage.token != undefined) {
        configCounter--;
        if (this.config.producer) {
          this.$store.state.fuarMod = this.config.fuarMod || false;
          this.spinners = false;
          this.$store.state.producer = this.config.producer;
          this.$store.state.systems = this.config.systems;
          this.$store.state.roboConfig.code = `CFR_${this.config?.sub_id?.toString().padStart(4, '0')}_${this.config?.city}`;
          document.documentElement.style.setProperty('--c-itech', this.$store.state.producer.color);
          clearInterval(configInterval);
        } else this.config = await this.$axios.get({ port: 4000, uri: '/config' });
        if (configCounter <= 10) this.spinners = false;
        else if (configCounter <= 0) this.$router.go();
      }
    }, 1000);

    setInterval(
      () => {
        this.checkByToken()
      },
      3 * 60 * 1000
    )
    setInterval(() => {
      this.time = this.$store.state.auth.time - Number((new Date().getTime() / 1000).toFixed())
    }, 1000)
  },
  computed: {
    license() {
      return this.$store.state.roboConfig.license
    },
    stationMonitoring() {
      return this.$store.state.stationMonitoring
    },
    services() {
      return this.$store.state.services
    },
    stationCount() {
      return this.$store.state.roboConfig.stationCount
    },
    controlPLC() {
      return this.$store.state.controlPLC
    },
    auth() {
      return this.$store.state.auth
    },
    authority() {
      return this.$store.state.auth?.authority
    },
    producer() {
      return this.$store.state.producer
    },
    machine_data() {
      return this.$store.state.machine_data
    },
    authorization() {
      return this.$store.state.auth?.authorization || {}
    }
  },
  watch: {
    async selected_machine() {
      if (this.$store.state.auth.authority && this.selected_machine != undefined) {
        let findMachine = this.$store.state.machine_data?.find(x => x.machine_id == this.selected_machine)
        let subDomain = this.machineAddr[findMachine?.code?.split('-')[0]] 
        if (window.location.host.split('.')[0] == subDomain || this.devStatus) {
          localStorage.selected_machine = this.selected_machine
          this.$router.go()
        }
        else this.baseControl(subDomain)
      }
    }
  }
}
</script>
